import { render } from "./SubmitGameDialog.organism.vue?vue&type=template&id=72a06362&bindings={\"isOpen\":\"props\",\"gameConfig\":\"props\",\"playersOption\":\"props\",\"gameName\":\"setup\",\"players\":\"setup\",\"onGameSelect\":\"setup\",\"onTagSelection\":\"setup\",\"onSubmit\":\"setup\",\"selectOptions\":\"setup\"}"
import script from "./SubmitGameDialog.organism.vue?vue&type=script&lang=ts"
export * from "./SubmitGameDialog.organism.vue?vue&type=script&lang=ts"
script.render = render

export default script